import React from "react";

import { SelectedResource } from "./selectedResource";
import { Props } from "./types";
import styles from "./styles.scss";
import { AddResourcesButton } from "./addResourcesButton";
import { SelectedEveryone } from "./selectedEveryone";

function SelectedResourcesList(props: Props) {
  return (
    <div className={styles.selectedResourcesList}>
      {props.isEveryoneSelected && (
        <SelectedEveryone unSelect={() => props.selectEveryone(false)} />
      )}
      {props.selectedResources.map((resource) => (
        <SelectedResource
          resource={resource}
          key={resource.uuid}
          removeSelectedResource={(resource) => {
            props.selectResources(
              props.selectedResources.filter(
                ({ uuid }) => resource.uuid !== uuid,
              ),
            );
          }}
        />
      ))}
      <div className={styles.button}>
        <AddResourcesButton
          selectedResources={props.selectedResources}
          project={props.project}
          roles={props.roles}
          selectResources={props.selectResources}
          selectRole={props.selectRole}
          isEveryoneSelected={props.isEveryoneSelected}
          selectEveryone={props.selectEveryone}
        />
      </div>
    </div>
  );
}

export { SelectedResourcesList };
